import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { TextField } from "@mui/material";
import { SmsContainer, generateInputs } from "./SmsInput";
import { useInputLogic } from "./useInputLogic";
import { CloseIcon } from "../Core/Icons/Close";
import axios from "axios";
import { useAppInfoWithReject } from "@/hooks/useAppInfoWithReject";
import { CancelService } from "@/api/service/CancelService";
import { RetrySVG } from "./RetrySVG";
import { ApiService } from "@/api/service/ApiService";
import { sendEventToAmplitude } from "@/utils/sendEventToAmplitude";
import { useSelector } from "react-redux";
import { pushToDataLayer } from "@/utils/gtm";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 768,
  bgcolor: "background.paper",
  boxShadow: 24,
  padding: "32px",
  borderRadius: "32px",
};

export default function Otp({
  open,
  setOpen,
  phone,
  goToPage,
  setOpenReject,
  timeOut,
}) {
  const { api } = ApiService();
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [resss, setr] = React.useState(false);
  const { clientInfo, incomeVerification } = useSelector(
    (state: any) => state.user
  );

  const { errorText, getAppInfo, appInfo, setDisconnect } =
    useAppInfoWithReject({
      setOpenRejectModal: setOpenReject,
    });

  const { otpInputs, inputChange, setOtpInputs } = useInputLogic(4);

  React.useEffect(() => {
    if (
      appInfo.processingEventStatus === "UNPROCESSED" &&
      appInfo.eventName === "VERIFICATION"
    ) {
      (async () => {
        const { data } = await api.post(
          `/application/growing-business/verify-otp`,
          {
            message: {
              ru: "",
              kz: "",
            },
            password: otpInputs.join(""),
          }
        );
        if (data) {
          // data.processingEventStatus === "PROCESSED" &&
          // data.eventName === "VERIFICATION"
          goToPage();
          handleClose();
        }
      })();
    }
  }, [appInfo.eventName]);

  const validateCode = async (code: any) => {
    if (code.length === 4) {
      try {
        sendEventToAmplitude("online_credit_otp_confimed", {
          flow: incomeVerification
            ? "с подтверждением дохода"
            : "без подтверждения дохода",
        });
        pushToDataLayer("online_credit_ip_otp_success");
        await getAppInfo();
      } catch (e) {
        throw e;
      }
    }
  };

  React.useEffect(() => {
    validateCode(otpInputs.join(""));
  }, [otpInputs]);

  const [timer, setTimer] = React.useState(timeOut);
  const [timerStr, setTimerStr] = React.useState("");
  const [sendClick, setSendClick] = React.useState(false);

  React.useEffect(() => {
    let timeOut = setInterval(() => {
      if (timer !== 0 && !sendClick) {
        setTimer(timer - 1);
        let minutes = Math.floor(timer / 60);
        let seconds = timer - minutes * 60;
        setTimerStr(minutes + ":" + (seconds < 10 ? "0" + seconds : seconds));
      }
    }, 1000);
    return () => clearInterval(timeOut);
  }, [timer]);

  const { cancelAndRedirect } = CancelService();

  const retryOtp = async () => {
    setTimerStr("");
    setTimer(timeOut);

    const { data } = await api.post(
      `/application/growing-business/resend-otp`,
      {}
    );
    if (data) {
      setOtpInputs(generateInputs(4, "string"));
    }
  };

  return (
    <Modal
      open={open}
      // onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={(theme) => ({
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "768px",
          bgcolor: "background.paper",
          boxShadow: 24,
          padding: "32px",
          borderRadius: "32px",
          [theme.breakpoints.down("sm")]: {
            width: "343px",
            padding: "16px",
            borderRadius: "16px",
          },
        })}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={(theme) => ({
              fontSize: "24px",
              fontWeight: "600",
              lineHeight: "32px",
              marginBottom: "8px",
              [theme.breakpoints.down("sm")]: {
                fontSize: "20px",
                lineHeight: "24px",
              },
            })}
          >
            Введите код из SMS
          </Typography>
          <button
            style={{ background: "none", border: "none", cursor: "pointer" }}
            onClick={() => {
              setDisconnect(true);
              cancelAndRedirect();
              handleClose();
            }}
          >
            <CloseIcon />
          </button>
        </Box>
        <Typography
          sx={(theme) => ({
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "22px",
            marginBottom: "32px",
            maxWidth: "632px",
            [theme.breakpoints.down("sm")]: {
              marginBottom: "24px",
            },
          })}
        >
          Мы отправили SMS с 4-х значным кодом подтверждения на номер {phone}
        </Typography>
        <Box
          sx={(theme) => ({
            display: "flex",
            alignItems: "center",
            [theme.breakpoints.down("sm")]: {
              flexDirection: "column",
              alignItems: "flex-start",
            },
          })}
        >
          <SmsContainer
            inputAmount={4}
            isValid={false}
            inputChange={inputChange}
          />
          {timer > 0 ? (
            <Typography
              sx={(theme) => ({
                color: "#676971",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "22px",
                marginLeft: "24px",
                [theme.breakpoints.down("sm")]: {
                  marginLeft: "0",
                  marginTop: "16px",
                },
              })}
            >
              Прислать другой код через {timerStr} секунд
            </Typography>
          ) : (
            <Box
              component="button"
              onClick={retryOtp}
              sx={(theme) => ({
                display: "flex",
                alignItems: "center",
                marginLeft: "24px",
                backgroundColor: "#fff",
                border: "none",
                [theme.breakpoints.down("sm")]: {},
              })}
            >
              <RetrySVG />
              <Typography
                sx={(theme) => ({
                  color: "#27AE60",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "24px",
                  marginLeft: "8px",
                  [theme.breakpoints.down("sm")]: {},
                })}
              >
                Отправить код повторно
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Modal>
  );
}
